"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const enums_1 = require("../types/enums");
const utils_1 = require("./utils");
exports.default = (pageType, parameters) => {
    let request = {
        adword: (parameters && (0, utils_1.sanitizeUrl)(parameters.get('adword'))) || 'NULL',
        cmd: (parameters && (0, utils_1.sanitizeUrl)(parameters.get('cmd'))) || 'NULL',
        newsletter: (parameters && (0, utils_1.sanitizeUrl)(parameters.get('newsletter'))) || 'NULL',
    };
    switch (pageType) {
        case enums_1.PageType.CART_INTERMEDIATE:
        case enums_1.PageType.CART:
        case enums_1.PageType.ACCOUNT:
        case enums_1.PageType.ACCOUNT_AFTER_LOGIN:
        case enums_1.PageType.ACCOUNT_AFTER_REGISTRATION:
        case enums_1.PageType.ACCOUNT_ORDER:
        case enums_1.PageType.ACCOUNT_ORDER_DETAILS:
        case enums_1.PageType.CHECKOUT_ADDRESS_AFTER_LOGIN:
        case enums_1.PageType.CHECKOUT_ADDRESS:
        case enums_1.PageType.CHECKOUT_ADDRESS_AFTER_REGISTRATION:
        case enums_1.PageType.CHECKOUT_CONFIRMATION:
        case enums_1.PageType.CHECKOUT_DELIVERY:
        case enums_1.PageType.CHECKOUT_PAYMENT:
        case enums_1.PageType.CHECKOUT_VERIFICATION:
        case enums_1.PageType.LOGIN:
        case enums_1.PageType.OFFER:
        case enums_1.PageType.HOME:
        case enums_1.PageType.MARKETING:
        case enums_1.PageType.NEWSLETTER_UNSUBSCRIBE:
            request = Object.assign(Object.assign({}, request), { campaign: (parameters && (0, utils_1.sanitizeUrl)(parameters.get('campaign'))) || 'NULL', expa: (parameters && (0, utils_1.sanitizeUrl)(parameters.get('expa'))) || 'NULL', product: (parameters && (0, utils_1.sanitizeUrl)(parameters.get('product'))) || 'NULL', quantity: (parameters && (0, utils_1.sanitizeUrl)(parameters.get('quantity'))) || 'NULL', subID: (parameters && (0, utils_1.sanitizeUrl)(parameters.get('subID'))) || 'Not found' });
            break;
        case enums_1.PageType.PDP:
        case enums_1.PageType.PDP_AFTER_LOGIN:
        case enums_1.PageType.PDP_AFTER_REGISTRATION:
            request = Object.assign(Object.assign({}, request), { product: (parameters && (0, utils_1.sanitizeUrl)(parameters.get('product'))) || 'NULL', quantity: (parameters && (0, utils_1.sanitizeUrl)(parameters.get('quantity'))) || 'NULL' });
            break;
        default:
        // do nothing
    }
    return request;
};
//# sourceMappingURL=create.request.data.js.map